const f = <T>(name: string, value: T): void => {
    document.cookie = `${name}=${JSON.stringify(value)};path=/;domain=${
        window.location.hostname
    };secure;SameSite=None`;
};

export default f;
